import { Component, Input } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { CognitoService } from '../../../../services/cognito.service';
import { Subscription } from 'rxjs';
import { CognitoUserPool } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-user-pools-dropdown-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './user-pools-dropdown-field.component.html',
	styleUrl: './user-pools-dropdown-field.component.scss',
})
export class UserPoolsDropdownFieldComponent extends BaseFieldComponent {
	@Input('multiple') public multiple: boolean = false;

	private sub: Subscription | undefined;
	public options: DropdownOption[] = [];

	constructor(private cognitoService: CognitoService) {
		super();

		this.sub = this.cognitoService.pools$.subscribe((pools: CognitoUserPool[]) => {
			this.options = pools.map((pool: CognitoUserPool) => ({
				value: pool.id,
				label: pool.name,
			}));
		});
	}

	/**
	 * All validators required for this field.
	 * @date 7/15/2022 - 4:30:09 PM
	 *
	 * @public
	 * @static
	 * @override
	 * @type {ValidatorFn[]}
	 */
	public static override validators: ValidatorFn[] = [Validators.required];

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}
}
